import { useFormContext, useWatch } from "react-hook-form";
import { CurrencyDollarCircle, User01 } from "@untitledui/icons";
import { MetricCard } from "@tricura/atlas-ui";
import type { ScheduleFormData } from "../schema";

const formatCurrency = (raw: string) => {
    const n = Number(raw);
    if (!raw || Number.isNaN(n)) return "—";
    return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(n);
};

export function SummaryCards() {
    const { control } = useFormContext<ScheduleFormData>();
    const rateUnadjusted = useWatch({ control, name: "rateUnadjusted" }) || "";
    const rateAdjusted = useWatch({ control, name: "rateAdjustedOccupancy" }) || "";

    return (
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <MetricCard
                icon={CurrencyDollarCircle}
                label="Rate Unadjusted"
                value={formatCurrency(rateUnadjusted)}
                tooltip="Total Unadjusted Premium ÷ Total Equivalency. Computed server-side."
                data-autotest="schedule-summary-card-rate-unadjusted"
            />
            <MetricCard
                icon={User01}
                label="Rate Per Adjusted Occupancy"
                value={formatCurrency(rateAdjusted)}
                tooltip="Premium per occupied bed-day, weighted by relativity factors."
                data-autotest="schedule-summary-card-rate-adjusted"
            />
        </div>
    );
}
